import React from 'react';
import img2 from './img/about.svg';
import pimg from './img/pranjal.svg';
import jimg from './img/jai.svg';

function About(props) {
    return (
        <>
          <div className="container d-flex justify-content-center cont-main">
                <div className="container dash-cont mt-3 p-5">
                <div>
                    <h1 className="mb-1" style={{color:"white"}}>Hello... People</h1>
                    <h4 className="mb-5 text-white">Do You Want To know About Us</h4>    
            </div>
            </div>
            </div>
    
           <div className="container main-container2">
       <div className="row">
       <div className="col-lg-6 col-md-6 text-center container-two">
               <img src={img2} alt="" className="img-fluid" />
           </div>
       <div className="col-lg-6 col-md-6  d-flex justify-content-center align-items-center pt-5">
                   <p>
                   <p className="main-text1"> Hello Friends </p>
                   <p className="main-context">We are just two teenagers who decided to contribute to our society with our web development skills.</p>
                    <p className="main-context">We are helping our people by donating Oxygen cylinders, Plasma, Blood for those who are in urgent require.</p>
                    <p className="main-context">This website act as a medium between the giver (one who want to donate any of the resources) and Taker (who need this resource for their friend and family).</p>
                   </p>
               </div>
           </div>
       </div>
    
           <div className="container main-container2">
           <div className="container text-center">
           <hr />
           <h1>Our Team</h1>
           <hr />
           </div>
         
       <div className="row">
       <div class="col-lg-6 col-md-6 mb-lg-0 mb-5 text-center">
      <div class="avatar mx-auto">
        <img src={pimg} class="img-fluid rounded-circle z-depth-1"
          alt="Sample avatar" />
      </div>
      <h5 class="font-weight-bold mt-4 mb-3">Pranjal Tiwari</h5>
      <p class="text-uppercase blue-text"><strong>Web Designer</strong></p>
      <p class="grey-text">React and Django Developer</p>
      <ul class="list-unstyled mb-0">
        <a class="p-2 fa-lg fb-ic" href="">
          <i class="fab fa-facebook-f blue-text"> </i>
        </a>
      
        <a class="p-2 fa-lg ins-ic" href="https://www.instagram.com/i_mpranjal/">
          <i class="fab fa-instagram blue-text"> </i>
        </a>
      </ul>
    </div>

       <div class="col-lg-6 col-md-6 mb-lg-0 mb-5 text-center">
      <div class="avatar mx-auto">
        <img src={jimg} class="img-fluid rounded-circle z-depth-1"
          alt="Sample avatar" />
      </div>
      <h5 class="font-weight-bold mt-4 mb-3">Aanand Bhai</h5>
      <p class="text-uppercase blue-text"><strong>Web Designer</strong></p>
      <p class="grey-text">React and Firebase</p>
      <ul class="list-unstyled mb-0">
    
      
        <a class="p-2 fa-lg ins-ic" href="https://www.instagram.com/divya_grd/">
          <i class="fab fa-instagram blue-text"> </i>
        </a>
      </ul>
    </div>
       </div>
       </div>
        </>
    );
}

export default About;